import axios from 'axios';

import {
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
} from '../../../components/CertsList/CertsListSidePanel/constant';
import { httpService } from '../../../http-service/httpService';
import {
  axiosTimeoutConfig,
  FORCED_CANCELLATION_MESSAGE,
  SET_CERT_LIST_CONNECTED_TILE_ID,
  SET_CERT_LIST_SIBLINGS_TILE_ID,
  SET_CERT_LIST_SIDEPANEL_VISIBLE,
  SET_CERTS_LIST_SIDEPANEL_LOADING,
  SET_CERTS_LIST_SIDEPANEL_METADATA,
  SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE,
} from '../types';
import {
  URL_SIDE_PANEL_HISTORY_API,
  URL_SIDE_PANEL_PROGRESS_API,
  URL_SIDE_PANEL_SUMMARY_API,
} from '../urls';

let cancelTokenForSidePanelSummary;
let cancelTokenForSidePanelHistory;
let cancelTokenForSidePanelProgressDecision;
let cancelTokenForSidePanelProgressType;

export const setIsSidePanelVisible = (state) => (dispatch, getState) => {
  dispatch({
    type: SET_CERT_LIST_SIDEPANEL_VISIBLE,
    payload: state,
  });

  // Whenever sidepanel is closed, we need to clear connectedTileId, sidePanelMetaData, and earlier loaded data
  if (!state) {
    const { sidePanelMetaData, connectedTileId } =
      getState().certifications.list.sidePanel;

    if (sidePanelMetaData) {
      dispatch({
        type: SET_CERTS_LIST_SIDEPANEL_METADATA,
        payload: null,
      });
    }

    if (connectedTileId) {
      dispatch({
        type: SET_CERT_LIST_CONNECTED_TILE_ID,
        payload: null,
      });
    }

    dispatch({
      type: SET_CERT_LIST_SIBLINGS_TILE_ID,
      payload: { prev: null, next: null },
    });
  }
};

export const setConnectedTileId = (tileId) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_CONNECTED_TILE_ID,
    payload: tileId,
  });

  // When ever tile Id is set then, loading will go to true
  dispatch({
    type: SET_CERTS_LIST_SIDEPANEL_LOADING,
    payload: true,
  });
};

export const setSiblingTileId = (prev, next) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_SIBLINGS_TILE_ID,
    payload: { prev, next },
  });
};

export const setIsSidePanelLoading = (isLoading) => (dispatch) => {
  dispatch({
    type: SET_CERTS_LIST_SIDEPANEL_LOADING,
    payload: isLoading,
  });
};

export const setSidePanelMetaData = (metaData) => (dispatch) => {
  dispatch({
    type: SET_CERTS_LIST_SIDEPANEL_METADATA,
    payload: metaData,
  });
};

export const getSidePanelSummary = (certkey) => async () => {
  const body = {
    certkey: String(certkey),
    certificationSummary: '1',
  };

  try {
    if (cancelTokenForSidePanelSummary) {
      cancelTokenForSidePanelSummary.cancel(FORCED_CANCELLATION_MESSAGE);
    }

    cancelTokenForSidePanelSummary = axios.CancelToken.source();

    const { data } = await httpService.post(URL_SIDE_PANEL_SUMMARY_API, body, {
      ...axiosTimeoutConfig,
      cancelToken: cancelTokenForSidePanelSummary.token,
    });

    return { tab: LIST_SP_TAB_SUMMARY, data };
  } catch (error) {
    throw Error(JSON.stringify({ tab: LIST_SP_TAB_SUMMARY, error }));
  }
};

export const getSidePanelHistory = (certkey) => async () => {
  const body = {
    certkey: String(certkey),
    certificationHistory: '1',
  };

  try {
    if (cancelTokenForSidePanelHistory) {
      cancelTokenForSidePanelHistory.cancel(FORCED_CANCELLATION_MESSAGE);
    }

    cancelTokenForSidePanelHistory = axios.CancelToken.source();

    const { data } = await httpService.post(URL_SIDE_PANEL_HISTORY_API, body, {
      ...axiosTimeoutConfig,
      cancelToken: cancelTokenForSidePanelHistory.token,
    });

    return { tab: LIST_SP_TAB_HISTORY, data: data?.response || [] };
  } catch (error) {
    throw Error(JSON.stringify({ tab: LIST_SP_TAB_HISTORY, error }));
  }
};

export const getSidePanelProgress =
  (certkey, isProgressTabEnabled) => async () => {
    // TODO: Need to remove this logic when API is reeady to support other campaigns
    if (!isProgressTabEnabled) {
      return {
        tab: LIST_SP_TAB_PROGRESS,
        data: {
          status: 'Not avaliable for campaigns other than UM',
        },
      };
    }

    const decisionBody = {
      certkey: String(certkey),
      group_by: 'decision',
    };

    const typeBody = {
      certkey: String(certkey),
      group_by: 'type',
    };

    try {
      if (cancelTokenForSidePanelProgressDecision) {
        cancelTokenForSidePanelProgressDecision.cancel(
          FORCED_CANCELLATION_MESSAGE
        );
      }

      cancelTokenForSidePanelProgressDecision = axios.CancelToken.source();

      const { data: decisionData } = await httpService.post(
        URL_SIDE_PANEL_PROGRESS_API,
        decisionBody,
        {
          ...axiosTimeoutConfig,
          cancelToken: cancelTokenForSidePanelProgressDecision.token,
        }
      );

      if (cancelTokenForSidePanelProgressType) {
        cancelTokenForSidePanelProgressType.cancel(FORCED_CANCELLATION_MESSAGE);
      }

      cancelTokenForSidePanelProgressType = axios.CancelToken.source();

      const { data: typeData } = await httpService.post(
        URL_SIDE_PANEL_PROGRESS_API,
        typeBody,
        {
          ...axiosTimeoutConfig,
          cancelToken: cancelTokenForSidePanelProgressType.token,
        }
      );

      return {
        tab: LIST_SP_TAB_PROGRESS,
        data: {
          decision:
            decisionData?.response === 'Success' ? decisionData?.Summary : {},
          type:
            typeData?.response === 'Success'
              ? {
                  Summary: typeData?.Summary,
                  total: typeData?.total,
                  totalPending: typeData?.totalPending,
                }
              : {},
        },
      };
    } catch (error) {
      throw Error(JSON.stringify({ tab: LIST_SP_TAB_PROGRESS, error }));
    }
  };

// TODO: This is the temp state till the time Carousel is updated for BreadCrumb
export const setTempActionState = (actionState) => (dispatch) => {
  dispatch({
    type: SET_CERTS_LIST_SIDEPANEL_TEMP_ACTION_STATE,
    payload: actionState,
  });
};
